import React, { lazy, Suspense, useContext } from 'react';
import { getTenant } from '../../../Utils/storageUtils';
import { TenantType } from '../../../Utils/types';
import { isCommonTenant } from '../../CommonTenant/utils/configUtils';
import NativeLoader from '../../NativeLoader';
import { AppContext } from '../../../App';

const PBStocks = lazy(() => import('../../PaisaBazaar/Stocks'));
const PBStocksNewFlow = lazy(() => import('../../PaisaBazaar/StocksNewFlow'));
const CommonTenantStocksNewFlow = lazy(
  () => import('../../CommonTenant/StocksNewFlow'),
);

const JFSStocksETFs = lazy(() => import('../../JFS/StocksETFs'));
const AUStocksNewFlow = lazy(() => import('../../AUBank/StocksNewFlow'));
const YBStocks = lazy(() => import('../../YesBank/Stocks'));

interface StocksProps {
  onHoldingClick?: (holding: any) => void;
  onBack?: () => void;
}

const Stocks: React.FC<StocksProps> = ({ onHoldingClick, onBack }) => {
  const tenant = getTenant();
  const { data }: any = useContext(AppContext);

  console.log('inside wrapper stock of ', tenant, TenantType.AU);
  console.log(data.current.totalPortfolioValue);

  const renderTenantSpecificStocks = () => {
    if (isCommonTenant()) {
      return data?.current?.totalPortfolioValue ? (
        <CommonTenantStocksNewFlow onHoldingClick={onHoldingClick} />
      ) : (
        <CommonTenantStocksNewFlow />
      );
    }
    switch (tenant) {
      case TenantType.PB:
        return data?.current?.totalPortfolioValue ? (
          <PBStocksNewFlow onHoldingClick={onHoldingClick} />
        ) : (
          <PBStocks />
        );
      case TenantType.JFS:
        return <JFSStocksETFs />;
      case TenantType.AU:
        return <AUStocksNewFlow onHoldingClick={onHoldingClick} />;
      case TenantType.YESBANK:
        return <YBStocks onBack={onBack} />;
      case TenantType.MAHINDRA:
      default:
        return <PBStocks />;
    }
  };

  return (
    <Suspense fallback={<NativeLoader />}>
      {renderTenantSpecificStocks()}
    </Suspense>
  );
};

export default Stocks;
